import { Header, ProgressBar } from '@/components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { useInterval } from 'usehooks-ts'
import { StoreContext } from '@/store/Root.store'
import { axiosInstance } from '@/methods/axiosConfig'
import { devLog } from '@/methods/devLog'
import { forceRedirect } from '@/methods/forceRedirect'
import { API_URL } from '@/constants/apiUrl'

const POLL_INTERVAL = 3000

interface VideoVerifiedResponse {
  status: 'not-verified' | 'accepted' | 'rejected'
  rejectionReason?: string
  rejectionReasonType?: string
}

export const VideoVerifyingPage = observer(() => {
  const store = useContext(StoreContext)
  const { progressPage: trans } = store.TranslationsState.translationsNew

  const [done, setDone] = useState(false)
  const [isChecking, setIsChecking] = useState(false)
  const [rejectionInfo, setRejectionInfo] = useState<{
    reason?: string
    reasonType?: string
  } | null>(null)

  const checkVideoVerified = async () => {
    if (isChecking) return
    setIsChecking(true)

    try {
      const res = await axiosInstance.get<VideoVerifiedResponse>(
        `${API_URL}/electronic-id/is-video-verified`,
        { withCredentials: true }
      )

      if (res.data.status === 'accepted') {
        setDone(true)
        forceRedirect('/signature')
      } else if (res.data.status === 'rejected') {
        setDone(true)
        setRejectionInfo({
          reason: res.data.rejectionReason,
          reasonType: res.data.rejectionReasonType,
        })
      }
      // not-verified: keep polling
    } catch (e) {
      devLog(e)
    } finally {
      setIsChecking(false)
    }
  }

  useEffect(() => {
    checkVideoVerified()
  }, [])

  useInterval(
    () => {
      checkVideoVerified()
    },
    !done ? POLL_INTERVAL : null
  )

  if (rejectionInfo) {
    return (
      <div className="page-container mobile-m-10">
        {rejectionInfo.reason && <p>{rejectionInfo.reason}</p>}
        {rejectionInfo.reasonType && <p>{rejectionInfo.reasonType}</p>}
      </div>
    )
  }

  return (
    <div className="page-container mobile-m-10">
      <div className="layout__margined m-0-0-15">
        <Header>{trans.heading}</Header>
      </div>
      <div className="generic__subheading">{trans.wait}</div>
      <ProgressBar time={180} secondChance={true} showCounter={true} longerWait={trans.waitMore} />
    </div>
  )
})
